module.exports = __webpack_public_path__ + "catalog/items/radiator-modern-style/ModernStyleRadiator.png";